query ApplicationsForApplicationConsole {
    applications {
        domain

        name
    }
}
